import Request from '../index';
import STORAGE_NAME from '@/const/storage';

const storeRequest = new Request();

const DEFAULT_STORE_DOMAIN = 'accounts.dropnoxe.com';

const applyStoreRequestConfig = config => {
  const token = localStorage.getItem(STORAGE_NAME.ACCESS_TOKEN);
  const storeDomain = localStorage.getItem(STORAGE_NAME.STORE_DOMAIN) || DEFAULT_STORE_DOMAIN;
  const baseURL = `https://${storeDomain}/api/`;

  storeRequest.setBaseURL(baseURL);

  if (token) {
    storeRequest.setToken(token);
  } else {
    delete storeRequest.api.defaults.headers.common.Authorization;
    delete storeRequest.api.defaults.headers.common['x-access-token'];
  }

  if (config) {
    config.baseURL = baseURL;
    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['x-access-token'] = token;
    } else {
      delete config.headers.Authorization;
      delete config.headers['x-access-token'];
    }
  }

  return config;
};

applyStoreRequestConfig();

storeRequest.api.interceptors.request.use(config => applyStoreRequestConfig(config));

export default storeRequest;
